import { Stethoscope } from 'lucide-react';
import { canAccessAdmin } from './iamAccess';

/**
 * Shown to a user who HAS clinical access but arrived without a SMART launch.
 *
 * Deliberately not `/access-denied`. Nothing is denied here — the permission is
 * real and the account is fine. What is missing is the patient context the
 * clinical workspace exists to work within, and telling someone they lack
 * access when they do not is how a support ticket gets opened against a system
 * that is behaving correctly.
 *
 * The wording names the action that fixes it (open the patient in the EHR)
 * rather than describing the internal state ("no SMART session"), because the
 * reader is a clinician, not the person who built the launch flow.
 */
export function LaunchRequiredPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6 text-foreground">
      <div className="max-w-md space-y-4 text-center">
        <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-accent/10">
          <Stethoscope className="size-6 text-accent" aria-hidden="true" />
        </div>

        <h1 className="text-lg font-medium">Open a patient to begin</h1>

        <p className="text-sm leading-relaxed text-text-secondary">
          The clinical workspace works within a patient&apos;s chart, so it opens from your
          EHR rather than directly. Find the patient in your clinical system and launch
          March Health from their record.
        </p>

        <p className="text-xs text-text-tertiary">
          Your account has clinical access — there is nothing to request. This screen only
          means no patient is currently open.
        </p>

        {canAccessAdmin() ? (
          <p className="pt-2 text-sm">
            <a className="text-accent underline underline-offset-4" href="/admin">
              Go to the admin panel
            </a>
          </p>
        ) : null}
      </div>
    </div>
  );
}
